import { motion } from "framer-motion";
import React from "react";
import { useLanguage } from "../context/LanguageContext";

const CareerPlan = () => {
	const { t } = useLanguage();

	return (
		<section
			id="careerPlan"
			className="py-20 bg-white dark:bg-gray-900">
			<div className="container mx-auto px-4">
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.5 }}>
					<h2 className="text-3xl font-bold text-center mb-2">
						{t("careerPlanTitle")}
					</h2>
					<p className="text-xl text-center mb-6 text-gray-600 dark:text-gray-400">
						{t("careerPlanSubtitle")}
					</p>

					{/* Career journey introduction */}
					<div className="max-w-3xl mx-auto mb-12 text-center">
						<p className="text-gray-700 dark:text-gray-300 mb-4">
							{t("careerPlanIntro1")}
						</p>
						<p className="text-gray-700 dark:text-gray-300">
							{t("careerPlanIntro2")}
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
						<GoalCard
							title={t("cyberSecurityTraining")}
							description={t("cyberSecurityTrainingDescription")}
							goals={t("cyberSecurityTrainingGoals")}
							icon="🛡️"
							delay={0.1}
						/>
						<GoalCard
							title={t("pentestCareer")}
							description={t("pentestCareerDescription")}
							goals={t("pentestCareerGoals")}
							icon="🔍"
							delay={0.3}
						/>
						<GoalCard
							title={t("entrepreneurship")}
							description={t("entrepreneurshipDescription")}
							goals={t("entrepreneurshipGoals")}
							icon="💼"
							delay={0.5}
						/>
					</div>
				</motion.div>
			</div>
		</section>
	);
};

const GoalCard = ({ title, description, goals, icon, delay }) => {
	// Ensure goals is always an array
	const goalsList = Array.isArray(goals) ? goals : [goals].filter(Boolean);

	return (
		<motion.div
			initial={{ opacity: 0, y: 20 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.5, delay }}
			whileHover={{ y: -10 }}
			className="bg-gray-50 dark:bg-gray-800 p-8 rounded-xl shadow-lg h-full">
			<div className="text-4xl mb-6">{icon}</div>
			<h3 className="text-xl font-bold mb-4">{title}</h3>
			{description && (
				<p className="text-gray-600 dark:text-gray-400 mb-6">
					{description}
				</p>
			)}
			<ul className="space-y-3">
				{goalsList.map((goal, index) => (
					<li
						key={index}
						className="flex items-start">
						<span className="text-blue-600 dark:text-blue-400 mr-2">
							•
						</span>
						<span className="text-gray-700 dark:text-gray-300">
							{goal}
						</span>
					</li>
				))}
			</ul>
		</motion.div>
	);
};

export default CareerPlan;
